export const isNumber = /[0-9]/; // 숫자
export const isEnglish = /[a-zA-Z]/; // 영문
export const isEnglishUp = /[A-Z]/; // 대문자영문
export const isEnglishDn = /[a-z]/; // 소문자영문
export const isSpecial = /[`~\[\]\/!@#$%\ ^&*()_+\-|<>?:.,\"\'\\\;{}]/; // eslint-disable-line
export const isSpecialExp = /[`~\[\]\/!@#$%^&*()_+\-|<>?:.,\"\'\\\;{}]/; // eslint-disable-line
// isSpecialExp는 스페이스 제외.
export const isKorea = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/; // 한글
export const url = "http://swftp.sw.co.kr:4000";
// 숫자 컴마 넣기.
export const numberWithCommas = (inputNumber) => {
  try {
    return inputNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } catch (error) {
    return inputNumber;
  }
};
// 현재 날짜 yyyyMMdd 형식으로 생성.
export const getToday = () => {
  var date = new Date();
  var year = date.getFullYear();
  var month = ("0" + (1 + date.getMonth())).slice(-2);
  var day = ("0" + date.getDate()).slice(-2);
  return year + month + day;
};
